// Affiliate IDs live in env so the public JSON stays neutral.
// Web builds substitute these into compound vendor URLs at click time.
export const AFFILIATE = {
  amazon_tag: import.meta.env.VITE_AMAZON_TAG || 'aiministries-20',
};

export function buildVendorUrl(template: string): string {
  return template
    .replace('{amazon_tag}', AFFILIATE.amazon_tag);
}

export function amazonProductUrl(asin: string): string {
  return `https://www.amazon.com/dp/${encodeURIComponent(asin)}?tag=${AFFILIATE.amazon_tag}`;
}
